import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  tableBody: {
    backgroundColor: theme.palette.type === 'dark' ? 'none' : '#f9f9f9',
  },

  tableRow: {
    height: 25,
    '& a': {
      textDecoration: 'underline',
    },
    '& > div': {
      borderBottomWidth: 0,
    },
    '&:last-child > div': {
      borderBottomWidth: 1,
    },
    '& > td': {
      borderBottom: 'none',
    },
    '&:last-child > td': {
      paddingBottom: '24px',
    },
  },

  thead: {
    '& *': {
      fontSize: 12,
      fontWeight: 500,
      color: theme.palette.type === 'dark' ? '#f9f9f9' : 'rgba(0, 0, 0, 0.54)',
      borderBottom: 'none',
    },
  },

  tableTitle: {
    fontSize: 16,
    borderBottom: 'none',
    paddingTop: '24px',
  },

  icon: {
    display: 'inline-block',
    width: 14,
    height: 14,
    verticalAlign: 'middle',
    marginRight: 8,
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg%3E%3Cpath fill='%23FFF' fill-opacity='0' d='M0 0H14V14H0z'/%3E%3Cpath fill='%23CCC' d='M11.043 4.604L12.104 5.664 6.78 10.987 1.457 5.664 2.518 4.604 6.78 8.866z' transform='translate(6.780330, 7.795495) rotate(-315.000000) translate(-6.780330, -7.795495)'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A")`,
  },

  routerLink: {
    color: theme.palette.primary.main,
  },
}));

export default useStyles;
